<template>
    <div>
        <!-- 合同信息 -->
        <compWrapper title="合同信息" theme="primary">
			<compFormQuery v-if="type=='query'" class="margin-top-15 margin-right-15" :formdata="getBase" :value="formData" :labelWidth="120" />
			<compFormEdit v-else class="margin-top-15 margin-right-15" ref="editform1" :formdata="getBase" v-model="formData" :labelWidth="120" />
            <vButtonGroup slot="footer" >
                <div class="text-right" v-if="type!=='query'">
                    <Button type="info" class="margin-left-10" @click="submit()">保存</Button>
                    <Button class="margin-left-10" @click="cancel">取消</Button>
                </div>
                <div class="text-right" v-if="type==='query'">
                    <Button class="margin-left-10" @click="cancel">返回</Button>
                </div>
		    </vButtonGroup>
		</compWrapper>
        <compWrapper :title="$t('global.common.attache',{defaultValue:'附件信息'})" theme="info">
			<compAttach
				class="margin-layout"
				ref="attachlist"
				:data.sync="attachList"
				:activeid="id"
				@on-update="getDetail"
                @on-updateItem="updateItem"
			></compAttach>
		</compWrapper>
        <compWrapper v-if="type==='query'" title="操作历史" theme="primary">
			<compLog :data="logList" :columns="columns"></compLog>
		</compWrapper>
		<vLoading size="large" transfer :loading="loading"></vLoading>


    </div>
</template>

<script>
import {
    HttpQueryCusContactOne,
    HttpSaveCusContact,
    HttGetwarehouseCarrierList,
} from "@/service/basicdata";
import compAttach from './attach';

// import { log } from "console";
import { mapGetters } from 'vuex';

export default {
    props:['querytype','activeid'],
    components: {
		compAttach,
	},
    data(){
        return {
            type: this.querytype || this.$route.params.type,
            id: this.activeid || this.$route.query.id,
            loading: false,
            formData:{
                id:this.id||null,
                contractType:1,
                warehouseId:null,
                warehouseCode:'',
            },
            remark:'',
            attachList: [],
            logList:[],
            getWareCusList:[],
            isCreate:false,
        }
    },
    created(){
        // 获取仓库承运商的下拉
        HttGetwarehouseCarrierList({
            active:1
        }).then(res=>{
            this.getWareCusList = res.data
        },err=>{
            this.$Message.error(res.message)
        })
        if(this.type === 'add') return;
        this.getDetail();

    },
    computed:{
        ...mapGetters('dictionary', ['getBillcusorgList']),
        ...mapGetters("common", ["getCurrencyList",]),
        getBase(){
            return [
                {
                    label:'合同类型',
                    tag:'vSelect',
                    options:[
                        {value:1,label:'客户销售合同'},
                        {value:2,label:'供应商采购合同'},
                    ],
                    props:{
                        filterable:true,
                    },
                    key:'contractType'
                },
                {
                    label:'合同名称',
                    tag:'vInput',
                    key:'contractName'
                },
                {
                    label:'签约对象',
                    tag:'vSelect',
                    options:[
                        {value:'Cope Supply Chain Limited',label:'Cope Supply Chain Limited'},
                        {value:'Elogistek LLC',label:'Elogistek LLC'},
                        {value:'运去哪(南京)供应链管理有限公司',label:'运去哪(南京)供应链管理有限公司'},
                        {value:'Cope Services INC',label:'Cope Services INC'},
                    ],
                    props:{
                        filterable:true,
                    },
                    key:'signTarget'
                },
                {
                    label:'客户公司名称',
                    tag:'vInput',
                    key:'customerCompanyName'
                },
                {
                    label:'合同签订日期',
                    tag: "vDatepicker",
                    props: {
                        format:'yyyy-mm-dd',
                        confirm: false,
                    },
				    key:'signDate',
                },
                {
                    label:'签约年限(年)',
                    tag:'vInputNumber',
                    key:'signYears',
                    props:{
                        min:0
                    },
                    on:{
                        "on-change":(val)=>{
                            if(this.isCreate){
                                this.isCreate=false
                                return
                            }
                            if(parseInt(val)===parseFloat(val)){
                                this.setSignEndDate(this.formData.signStartDate,val)
                            }
                        }
                    }
                },
                {
                    label:'签约起始日',
                    tag: "vDatepicker",
                    props: {
                        format:'yyyy-mm-dd',
                        confirm: false,
                    },
				    key:'signStartDate',
                    on:{
                        'on-change':(val)=>{
                            if(this.isCreate){
                                this.isCreate=false
                                return
                            }
                            if(parseInt(this.formData.signYears)===parseFloat(this.formData.signYears)){
                                this.setSignEndDate(val,this.formData.signYears);
                            }
                        }
                    },
                },
                {
                    label:'签约到期日',
                    tag: "vDatepicker",
                    props: {
                        format:'yyyy-mm-dd',
                        confirm: false,
                    },
				    key:'signEndDate',
                },
                {
                    label:'自动续约年限(年)',
                    tag:'vInputNumber',
                    key:'autoResignYears',
                    props:{
                        min:0
                    },
                    on:{
                        'on-change':(val)=>{
                            if(this.isCreate){
                                this.isCreate=false
                                return
                            }
                            if(parseInt(val)===parseFloat(val)){
                                this.setResignEndDate(val);
                            }
                        }
                    }
                },
                {
                    label:'续约到期日',
                    tag: "vDatepicker",
                    props: {
                        format:'yyyy-mm-dd',
                        confirm: false,
                    },
				    key:'resignEndDate',
                },
                {
                    label:'客户组织名称',
                    tag:'vSelect',
                    options:this.getBillcusorgList,
                    props:{
                        filterable:true,
                    },
                    key:'orgId',
                    show:this.formData.contractType===1,
                },
                {
                    label:'仓库/承运商',
                    tag:'vSelect',
                    options: this.getWareCusList.map(item=>{
                        return {
                            value:item.code,
                            label:item.name+'('+item.code+')'
                        }
                    }),
                    props:{
                        filterable:true,
                    },
                    key:'warefedex',
                    show:this.formData.contractType===2,
                    on:{
                        'on-change':()=>{
                            this.getWarehouseId();
                        }
                    },
                    render:()=>{
                        if(this.formData.warehouseId!=0){
                            let oneware = this.getWareCusList.filter(item=>{
                                return item.code == this.formData.warefedex
                            })[0]
                            return oneware?oneware.name+'('+oneware.code+')':this.formData.warefedex
                        }else{
                            return this.formData.warefedex
                        }
                    }
                },
                {
                    label:'我司销售员',
                    tag:'vInput',
                    key:'sellerName'
                },
                {
                    label:'保证金',
                    tag:'vInputNumber',
                    key:'securityDeposit',
                    props:{
                        step:100,
                        min:0
                    }
                },
                {
                    label:'币种',
                    tag:'vSelect',
                    options:this.getCurrencyList,
                    props:{
                        filterable:true
                    },
                    key:'currency'
                },
                {
                    label:'客户公司注册地',
                    tag:'vInput',
                    key:'customerCompanyRegisterAddress'
                },
                {
                    label:'客户业务联系人',
                    tag:'vInput',
                    key:'customerBusinessLinkPerson'
                },
                {
                    label:'客户业务联系人电话',
                    tag:'vInput',
                    key:'customerBusinessLinkPhone'
                },
                {
                    label:'客户业务联系邮箱',
                    tag:'vInput',
                    key:'customerBusinessLinkEmail',
                },
                {
                    label:'客户财务联系人',
                    tag:'vInput',
                    key:'customerFinancialLinkPerson'
                },
                {
                    label:'客户财务联系人电话',
                    tag:'vInput',
                    key:'customerFinancialLinkPhone'
                },
                {
                    label:'客户财务联系邮箱',
                    tag:'vInput',
                    key:'customerFinancialLinkEmail'
                },
                {
                    label:'是否需要到期提醒',
                    tag:'vSelect',
                    key:'isNotice',
                    options:[
                        {value:1,label:'需要'},
                        {value:0,label:'不需要'},
                    ],
                },
                {
					label: this.$t('global.common.notes', { defaultValue: "备注" }),
					tag: "vTextarea",
					key: "remark",
					required: false,
				}
            ]
        },
        columns() {
			return [
				{
					title: "NO",
					type: 'index',
                    width:60,
				},
                {
					title: "操作人",
					key: 'opUserName',
                    width:100,
				},
				{
					title: "操作类型",
					key: 'opAction',
                    width:100,
				},
				{
					title: "操作明细",
					key: 'opData'
				},
                {
					title: "操作时间",
					key: 'opAt',
				},
			]
		},
    },
    methods:{
        setSignEndDate(startDate,year){
            if(startDate && year){
            const date=new Date(startDate);
            date.setFullYear(date.getFullYear()+parseInt(year));
            date.setDate(date.getDate());
            const dateYear = date.getFullYear();
            const dateMonth = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
            const dateDate = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
            const result=dateYear+'-'+dateMonth+'-'+dateDate;
            this.formData.signEndDate?this.formData.signEndDate=result:this.$set(this.formData,'signEndDate',result);
            this.setResignEndDate(this.formData.autoResignYears)
            }
        },
        setResignEndDate(year){
            if(year>=0&&this.formData.signEndDate){
                const date=new Date(this.formData.signEndDate)
                date.setFullYear(date.getFullYear()+parseInt(year));
                date.setDate(date.getDate());
                const dateYear = date.getFullYear();
                const dateMonth = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
                const dateDate = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
                const result=dateYear+'-'+dateMonth+'-'+dateDate;
                this.formData.resignEndDate?this.formData.resignEndDate=result:this.$set(this.formData,'resignEndDate',result);
            }
        },
        getWarehouseId(){
            this.getWareCusList.filter((item)=>{
                if(item.code===this.formData.warefedex && item.type == 0){
                    this.formData.warehouseCode = item.code;
                    this.formData.warehouseId = item.id;
                    this.formData.type = 0;
                }else if(item.code===this.formData.warefedex && item.type == 1){
                    this.formData.carrierId = item.id;
                    this.formData.carrierCode = item.code;
                    this.formData.warehouseCode = '';
                    this.formData.type = 1;
                }
            })
        },
        async getDetail(){
			this.loading = true;
            this.isCreate=true;
            await HttpQueryCusContactOne({
                id:this.id
            }).then(res=>{
				this.loading = false;
                this.formData = {
                    id:this.id,
                    //合同信息
                    carrierId : res.data.carrierId,
                    // carrierCode : res.data.carrierCode,
                    contractType:res.data.contractType,
                    contractName:res.data.contractName,
                    signTarget:res.data.signTarget,
                    customerCompanyName:res.data.customerCompanyName,
                    signDate:res.data.signDate,
                    signYears:res.data.signYears,
                    signStartDate:res.data.signStartDate,
                    signEndDate:res.data.signEndDate,
                    autoResignYears:res.data.autoResignYears,
                    resignEndDate:res.data.resignEndDate,
                    orgName:res.data.orgName,
                    orgId:res.data.orgId,
                    warehouseId:res.data.warehouseId,
                    warefedex:res.data.warehouseCode?res.data.warehouseCode:res.data.carrierCode,
                    sellerName:res.data.sellerName,
                    securityDeposit:res.data.securityDeposit,
                    currency:res.data.currency,
                    customerCompanyRegisterAddress:res.data.customerCompanyRegisterAddress,
                    customerBusinessLinkPerson:res.data.customerBusinessLinkPerson,
                    customerBusinessLinkPhone:res.data.customerBusinessLinkPhone,
                    customerBusinessLinkEmail:res.data.customerBusinessLinkEmail,
                    customerFinancialLinkPerson:res.data.customerFinancialLinkPerson,
                    customerFinancialLinkPhone:res.data.customerFinancialLinkPhone,
                    customerFinancialLinkEmail:res.data.customerFinancialLinkEmail,
                    isNotice:res.data.isNotice,
                    remark:res.data.remark,
                    //合同文件
                    attachList:{
                        fileName:res.data.attachList.fileName,
                        fileUrl:res.data.attachList.fileUrl,
                        updatedAt:res.data.attachList.updatedAt
                    },
                    //操作历史
                    opList:{
                        opUserName:res.data.opList.opUserName,
                        opAt:res.data.opList.opAt,
                        opAction:res.data.opList.opAction==='create'?'创建':res.data.opList.opAction==='update'?'更新':'--',
                        opData:res.data.opList.opData,
                    }
                }
                this.attachList=res.data.attachList;
                this.logList=res.data.opList;
            },err=>{
				this.loading = false;
                this.$Message.error({content:err.message,duration:10,closable:true});
            })
        },
        updateItem(){
            this.formData.attachModelList=this.attachList.map(item=>{
                return {
                    id:item.id,
                    fileUrl:item.fileUrl,
                    fileName:item.fileName
                }
            })
        },
        async submit(){
            // console.log('formData');
            // console.log(this.formData)
            // 保存
            const valid=await this.$refs.editform1.validate();
			if(!valid) return;
			this.loading = true;
            this.$refs.attachlist.deleteItems();
            this.getWarehouseId();
            HttpSaveCusContact(this.formData).then(res=>{
				this.loading = false;
                this.$Message.success(res.message);
                this.cancel();
            },err=>{
                this.$Message.error({content:err.message,duration: 20,closable: true});
				this.loading = false;
            })
        },
        cancel(){
            this.$router.push({
                name: "basicdataCustomerontract"
            })
        }
    }
}
</script>
